<script setup lang="ts">
import { shallowRef, watch } from 'vue';
import { useElementVisibility } from '@vueuse/core';
import MarketCard from './MarketCard.vue';
import LoadingMarketCard from './LoadingMarketCard.vue';
import type { ForecastTraderDetailedMarket } from '@/types/forecasttrader.types';

const props = withDefaults(
  defineProps<{
    market: ForecastTraderDetailedMarket;
    size: 'large' | 'small';
    limit?: number;
    origin?: string;
    openExternalContracts?: boolean;
    priceSide?: 'bid' | 'ask';
    eager?: boolean;
  }>(),
  {
    limit: 2,
    origin: 'landing',
  },
);

defineEmits<{ 'view-more': [] }>();

const target = shallowRef<HTMLElement>();
const rawVisible = useElementVisibility(target, { rootMargin: '800px' });

const isVisible = shallowRef(!!props.eager);
watch(rawVisible, (val) => {
  if (val) isVisible.value = true;
});
</script>

<template>
  <div ref="target" class="lazy-market-card">
    <MarketCard
      v-if="isVisible"
      :market="market"
      :size="size"
      :limit="limit"
      :origin="origin"
      :open-external-contracts="openExternalContracts"
      :price-side="priceSide"
      @view-more="$emit('view-more')"
    />
    <LoadingMarketCard v-else :size="size" :limit="limit" />
  </div>
</template>

<style scoped>
.lazy-market-card {
  contain: layout style paint;
}
</style>
